module.exports = "/_next/static/images/Logoengnegative-b51406b938159674c72746a431509285.png";